module.exports = __webpack_public_path__ + "static/media/Maropost-Logo.8c2271f7.png";